import UserAvatar from "@/components/media/UserAvatar";
import type { User } from "@/types";

import { useMessengerContext } from "../../store";

const sizes = {
  md: "size-10",
  lg: "size-12",
};

export default function ConversationUserImage({
  user,
  size = "md",
}: {
  user: User<true>;
  size?: keyof typeof sizes;
}) {
  const isUserOnline = useMessengerContext(({ online_users }) =>
    online_users.some((onlineUser) => onlineUser.id === user.id),
  );

  return (
    <UserAvatar
      user={user}
      size={size}
      isOnline={isUserOnline}
      disableTooltip
    />
  );
}
